// extracted by mini-css-extract-plugin
export var contrastLow = "_34-1";
export var externalLink = "_34-2";
export var externalLinkIcon = "_34-3";
export var link = "_34-0";
export var linkLabel = "_34-4";